import React from "react";
import {
  ALIGN_ITEMS,
  DISPLAY,
  FLEX_DIRECTION,
  FONT_SIZE,
  JUSTIFY_CONTENT,
  SPACING,
} from "../../../Constants/Enums/styles.enum";
import { DocumentIcon } from "../../Icon/DocumentIcon";
import { FontFamily } from "../../../Constants/Enums/FontFamily.enums";
import { DownloadIcon } from "../../Icon/DownloadIcon";
import { TextButton } from "../../Button/TextButton";

export const DownloadLedger = () => {
  return (
    <div
      style={{
        display: DISPLAY.FLEX,
        flexDirection: FLEX_DIRECTION.ROW,
        alignItems: ALIGN_ITEMS.CENTER,
        justifyContent: JUSTIFY_CONTENT.SPACE_BETWEEN,
        backgroundColor: "#FFF9F5",
        border: "2px solid #FFE5D9",
        borderRadius: "12px",
        padding: `${SPACING.S16} ${SPACING.S20}`,
        gap: SPACING.S16,
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          display: DISPLAY.FLEX,
          alignItems: ALIGN_ITEMS.CENTER,
          gap: SPACING.S16,
        }}
      >
        <DocumentIcon />
        <div
          style={{
            display: DISPLAY.FLEX,
            flexDirection: FLEX_DIRECTION.COLUMN,
            gap: SPACING.S4,
          }}
        >
          <div
            style={{
              fontFamily: FontFamily.ROBOTO_BOLD,
              fontSize: FONT_SIZE.F16,
              color: "#333",
            }}
          >
            Download Mark Ledger Report
          </div>
          <div
            style={{
              fontFamily: FontFamily.ROBOTO_REGULAR,
              fontSize: FONT_SIZE.F12,
              color: "#666",
            }}
          >
            Get the complete mark ledger report for this result
          </div>
        </div>
      </div>

      <div style={{ flexShrink: 0 }}>
        <TextButton
          onClick={() => {}}
          title="Download"
          icon={<DownloadIcon />}
        />
        {/* <Button
          text="Download"
          btnType={BtnType.primary}
          btnSize={BtnSize.md}
          onClick={() => {}}
          loading={false}
          additionalComponent={<DownloadIcon />}
          btnStyle={{
            fontSize: "15px",
            fontWeight: "600",
            padding: "12px 28px",
            minWidth: "150px",
          }}
        /> */}
      </div>
    </div>
  );
};
